// Delay Klaviyo form binding until idle
if(window.klaviyo){
  var _kq = window._klOnsite = window._klOnsite || [];
}
function initSplideSliders() {
    if (window.mainSliderMounted) {
        return
    }
    window.mainSliderMounted = !0;
    var main = new Splide("#main-slider", {
        type: "loop",
        rewind: !0,
        pagination: !1,
        arrows: !0,
        autoHeight: !1,
        drag: !0,
    });
    var thumbnails = new Splide("#thumbnail-slider", {
        fixedWidth: 90,
        fixedHeight: 90,
        rewind: !0,
        pagination: !1,
        cover: !0,
        isNavigation: !0,
        arrows: !0,
        gap: 3,
        drag: !0,
        breakpoints: {
            767: {
                fixedWidth: 88,
                fixedHeight: 88,
                arrows: !1,
            },
        },
    });
    main.sync(thumbnails);

    function updateHeight() {
        let slide = main.Components.Slides.getAt(main.index).slide;
        if (slide) {
            main.root.style.height = slide.offsetHeight + "px"
        }
    }
    main.mount().on("active resized", updateHeight);
    updateHeight();
    thumbnails.mount()
}
document.addEventListener("DOMContentLoaded", initSplideSliders);
document.addEventListener("DOMContentLoaded", function() {
    initSplideSliders()
});
let selectedSize = "";
let selectedFrame = "";
let currencySymbol = "$";
let userLocale = "en-US";
const sizePriceMap = {};

function toggleAvailabilityClass(quickbuy) {
    const productForm = document.querySelector(`${quickbuy ? ".inner " : ""} product-form.product-info`);
    if (!productForm) return;

    productForm.classList.remove("not-available", "na-18x24-gold", "na-24x36-framed", "na-gold-multiple");

    let customMsg = document.querySelector(".custom-availability-msg");
    if (customMsg) customMsg.remove();

    // ---------------------------------------------------------------------------
    // Gold Metal out-of-stock and 24x36 framed restrictions are DISABLED.
    // The original blocking logic is preserved below (commented out). To re-enable
    // the restrictions, uncomment the block.
    // ---------------------------------------------------------------------------
    /*
    let messageText = "";
    let isUnavailable = !1;
    let showNotifyLink = !0; // control whether CTA shows

    const goldRestrictedSizes = ["5 x 7", "8 x 10", "12 x 12", "11 x 14", "18 x 24", "20 x 30", "24 x 30", "16 x 20"];

    if (goldRestrictedSizes.includes(selectedSize) && selectedFrame === "Gold Metal") {
        productForm.classList.add("not-available", "na-gold-multiple");
        messageText = `${selectedSize} Gold Metal frames are temporarily out of stock. `;
        isUnavailable = !0;
    }
    else if (selectedSize === "24 x 36" && selectedFrame !== "Unframed") {
        productForm.classList.add("not-available", "na-24x36-framed");
        messageText = "Due to shipping constraints, we only offer 24x36 unframed. ";
        isUnavailable = !0;
        showNotifyLink = !1; // remove CTA for this case
    }

    if (isUnavailable) {
        const msgSpan = document.createElement("span");
        msgSpan.className = "custom-availability-msg";
        msgSpan.style.color = "red";
        msgSpan.style.fontSize = "14px";
        msgSpan.style.fontWeight = "600";
        msgSpan.style.display = "block";
        msgSpan.style.marginBottom = "12px";

        msgSpan.innerHTML = showNotifyLink
            ? `
              ${messageText}
              <span style="color:#007aff; font-weight:600;">
                <a href="#" class="gt-ntf-link" style="color:#007aff; text-decoration:underline;">Click here</a> to get notified when the product is available
              </span>
            `
            : `${messageText}`;

        const target = productForm.querySelector(".buy-buttons-row")
            || productForm.querySelector(".buy-buttons")
            || productForm;

        target.parentNode.insertBefore(msgSpan, target);

        if (showNotifyLink) {
            const link = msgSpan.querySelector(".gt-ntf-link");
            link.addEventListener("click", function(e) {
                e.preventDefault();
                window._klOnsite = window._klOnsite || [];
                window._klOnsite.push(["openForm", "Ta53hC"]);
            });
        }
    }
    */
}

const currencySymbolLocaleMap = {
    $: "en-US",
    "Rs.": "en-IN",
    "€": "de-DE",
    "£": "en-GB",
    "¥": "ja-JP",
    C$: "en-CA",
};

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
}

function getCurrencySymbol(text) {
    const trimmed = text.trim();
    const matchStart = trimmed.match(/^\p{Sc}/u);
    if (matchStart) return matchStart[0];
    const matchEnd = trimmed.match(/\p{Sc}$/u);
    if (matchEnd) return matchEnd[0];
    const fallback = trimmed.match(/[^\d.,\s]/);
    return fallback ? fallback[0] : "$"
}

function getLocaleFromCurrencySymbol(symbol) {
    return currencySymbolLocaleMap[symbol] || "en-US"
}

function getSeparators(locale) {
    const numberWithGroupAndDecimal = 1234567.89;
    const formatted = new Intl.NumberFormat(locale).format(numberWithGroupAndDecimal);
    const match = formatted.match(/(\D+)/g);
    if (match && match.length >= 2) {
        return {
            thousands: match[0],
            decimal: match[1]
        }
    }
    return {
        thousands: ",",
        decimal: "."
    }
}

function parseLocalizedNumber(numberString, separators) {
    const {
        thousands,
        decimal
    } = separators;
    const regex = new RegExp(`\\${thousands}`, "g");
    const cleaned = numberString.replace(regex, "");
    const normalized = cleaned.replace(decimal, ".");
    const number = parseFloat(normalized);
    return isNaN(number) ? 0 : number
}

function formatLocalizedNumber(number, locale) {
    return new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(number)
}

function updatePriceVisibility(quickbuy) {
    if (!selectedSize || !selectedFrame) return;
    const swatchPrices = document.querySelectorAll(`${quickbuy ? ".inner" : ""} .swatch-price`);
    let framedPrice = 0;
    let unframedPrice = 0;
    let detectedCurrencySymbol = currencySymbol;
    let detectedLocale = userLocale;
    swatchPrices.forEach((swatch) => {
        const titleElement = swatch.querySelector(`${quickbuy ? ".inner" : ""} .sp-title`);
        const priceSpan = swatch.querySelector(`${quickbuy ? ".inner" : ""} .sp-price`);
        if (!titleElement || !priceSpan || !priceSpan.dataset.price) return;
        const title = titleElement.textContent.toLowerCase();
        const priceString = priceSpan.dataset.price;
        const priceText = priceSpan.textContent;
        const extractedSymbol = getCurrencySymbol(priceText);
        const locale = getLocaleFromCurrencySymbol(extractedSymbol);
        const separators = getSeparators(locale);
        const numericPrice = parseLocalizedNumber(priceString, separators);
        if (detectedCurrencySymbol === "$") {
            detectedCurrencySymbol = extractedSymbol || detectedCurrencySymbol;
            detectedLocale = locale
        }
        if (title.includes(selectedSize.toLowerCase()) && title.includes("unframed")) {
            unframedPrice = numericPrice
        }
        if (title.includes(selectedSize.toLowerCase()) && title.includes(selectedFrame.toLowerCase())) {
            framedPrice = numericPrice
        }
    });
    currencySymbol = detectedCurrencySymbol;
    userLocale = getLocaleFromCurrencySymbol(currencySymbol);
    const separators = getSeparators(userLocale);
    swatchPrices.forEach((swatch) => {
        const titleElement = swatch.querySelector(`${quickbuy ? ".inner" : ""} .sp-title`);
        if (!titleElement) return;
        const title = titleElement.textContent.toLowerCase();
        if (selectedFrame.toLowerCase() === "unframed") {
            if (title.includes(selectedSize.toLowerCase()) && title.includes("unframed")) {
                swatch.style.display = ""
            } else {
                swatch.style.display = "none"
            }
        } else {
            if (title.includes(selectedSize.toLowerCase()) && title.includes(selectedFrame.toLowerCase())) {
                swatch.style.display = ""
            } else {
                swatch.style.display = "none"
            }
        }
    });
    const priceDifference = framedPrice - unframedPrice;
    const frameScope = quickbuy ? ".inner " : "";
    const frameLabelSpan =
        document.querySelector(
            `${frameScope}.option-selector[data-option="Premium Glass Framing"] .option-selector__label-value.js-color-text`
        ) ||
        document.querySelector(
            `${frameScope}.option-selector[data-option="Framing"] .option-selector__label-value.js-color-text`
        );
    if (frameLabelSpan) {
        let framePriceDiffElement = frameLabelSpan.nextElementSibling;
        if (framePriceDiffElement && framePriceDiffElement.classList.contains("price-difference")) {
            if (selectedFrame.toLowerCase() !== "unframed" && framedPrice > 0 && unframedPrice > 0) {
                const formattedDifference = formatLocalizedNumber(priceDifference, userLocale);
                framePriceDiffElement.textContent = ` (+${currencySymbol}${formattedDifference})`;
                framePriceDiffElement.style.display = ""
            } else {
                framePriceDiffElement.style.display = "none"
            }
        } else {
            if (selectedFrame.toLowerCase() !== "unframed" && framedPrice > 0 && unframedPrice > 0) {
                framePriceDiffElement = document.createElement("span");
                framePriceDiffElement.classList.add("price-difference");
                const formattedDifference = formatLocalizedNumber(priceDifference, userLocale);
                framePriceDiffElement.textContent = ` (+${currencySymbol}${formattedDifference})`;
                framePriceDiffElement.style.marginLeft = "4px";
                framePriceDiffElement.style.color = "black";
                framePriceDiffElement.setAttribute("aria-live", "polite");
                frameLabelSpan.parentNode.insertBefore(framePriceDiffElement, frameLabelSpan.nextSibling)
            }
        }
    }
    const sizeFieldset = document.querySelector(`${quickbuy ? ".inner" : ""
    } fieldset.option-selector[data-option="Size (Inches)"]`);
    if (sizeFieldset) {
        const sizeLegend = sizeFieldset.querySelector(`${quickbuy ? ".inner" : ""} legend.label`);
        if (sizeLegend) {
            let selectedSizeElement = sizeLegend.querySelector(`${quickbuy ? ".inner" : ""} .selected-size`);
            if (selectedSizeElement) {
                selectedSizeElement.textContent = ` ${selectedSize}`
            } else {
                selectedSizeElement = document.createElement("span");
                selectedSizeElement.classList.add("selected-size");
                selectedSizeElement.textContent = ` ${selectedSize}`;
                sizeLegend.appendChild(selectedSizeElement)
            }
            let sizePriceDiffElement = sizeLegend.querySelector(`${quickbuy ? ".inner" : ""} .size-price-difference`);
            if (sizePriceDiffElement) {
                sizePriceDiffElement.textContent = ` (${currencySymbol}${formatLocalizedNumber(
          unframedPrice,
          userLocale
        )})`;
                sizePriceDiffElement.style.display = ""
            } else {
                sizePriceDiffElement = document.createElement("span");
                sizePriceDiffElement.classList.add("size-price-difference");
                sizePriceDiffElement.textContent = `(${currencySymbol}${formatLocalizedNumber(
          unframedPrice,
          userLocale
        )})`;
                sizePriceDiffElement.style.marginLeft = "4px";
                sizePriceDiffElement.style.color = "black";
                sizePriceDiffElement.setAttribute("aria-live", "polite");
                sizeLegend.appendChild(sizePriceDiffElement)
            }
        }
    }
}

function initializeSelections(quickbuy) {
    const container = quickbuy ? document.querySelector(".inner") : document;
    if (!container) {
        console.error("Container element not found.");
        return
    }
    const defaultSizeRadio = container.querySelector('input[name*="size-inches-option"][value="5 x 7"]');
    if (defaultSizeRadio) {
        defaultSizeRadio.checked = !0;
        selectedSize = defaultSizeRadio.value;
        defaultSizeRadio.dispatchEvent(new Event("change", {
            bubbles: !0
        }))
    }
    const defaultFrameRadio = container.querySelector('input[name*="framing-option"][value="Unframed"]');
    if (defaultFrameRadio) {
        defaultFrameRadio.checked = !0;
        selectedFrame = defaultFrameRadio.value;
        defaultFrameRadio.dispatchEvent(new Event("change", {
            bubbles: !0
        }))
    }
    updatePriceVisibility(quickbuy);
    toggleAvailabilityClass(quickbuy)
}

function eventSizeChange(quickbuy) {
    console.log('Initializing size change tracking...');
    initializeSelections(!1);
    initializeSelections(!0);
    const sizeInputs = document.querySelectorAll(`${quickbuy ? ".inner" : ""} input[name*="size-inches-option"]`);
    console.log('Found size inputs:', sizeInputs.length);
    if (sizeInputs.length > 0) {
        sizeInputs.forEach((input) => {
            input.addEventListener("change", function(e) {
                if (e.target.checked) {
                    selectedSize = e.target.value;
                    console.log('Size changed to:', selectedSize);
                    console.log('Current frame:', selectedFrame);
                    updatePriceVisibility(!1);
                    updatePriceVisibility(!0);
                    toggleAvailabilityClass(!1);
                    toggleAvailabilityClass(!0);
                    window.snoogRefreshCosmeticPricing?.(quickbuy)
                }
            })
        })
    }
    const frameInputs = document.querySelectorAll(`${quickbuy ? ".inner" : ""} input[name*="framing-option"]`);
    if (frameInputs.length > 0) {
        frameInputs.forEach((input) => {
            input.addEventListener("change", function(e) {
                if (e.target.checked) {
                    selectedFrame = e.target.value;
                    console.log('Frame changed to:', selectedFrame);
                    console.log('Current size:', selectedSize);
                    updatePriceVisibility(!1);
                    updatePriceVisibility(!0);
                    toggleAvailabilityClass(!1);
                    toggleAvailabilityClass(!0);
                    window.snoogRefreshCosmeticPricing?.(quickbuy)
                }
            })
        })
    }
}
document.addEventListener("DOMContentLoaded", () => {
    eventSizeChange(!1);
    eventSizeChange(!0)
});

function appendUnframedPrices(quickbuy) {
    const sizePriceMap = {};
    const swatchPrices = document.querySelectorAll(`${quickbuy ? ".inner" : ""} .swatch-price`);
    swatchPrices.forEach(function(swatch) {
        const titleElement = swatch.querySelector(`${quickbuy ? ".inner" : ""} .sp-title`);
        const priceElement = swatch.querySelector(`${quickbuy ? ".inner" : ""} .sp-price`);
        if (titleElement && priceElement) {
            const titleText = titleElement.textContent.trim();
            if (titleText.endsWith("/ Unframed")) {
                const size = titleText.split("/")[0].trim();
                const price = priceElement.textContent.trim();
                sizePriceMap[size] = price
            }
        }
    });
    const labels = document.querySelectorAll(`${quickbuy ? ".inner" : ""} .option-selector__btns .opt-label`);
    labels.forEach(function(label) {
        const sizeSpan = label.querySelector(`${quickbuy ? ".inner" : ""} .js-value`);
        if (sizeSpan) {
            const sizeText = sizeSpan.textContent.trim();
            const unframedPrice = sizePriceMap[sizeText];
            if (unframedPrice) {
                if (!label.querySelector(`${quickbuy ? ".inner" : ""} .unframed-price`)) {
                    const priceSpan = document.createElement("span");
                    priceSpan.classList.add("unframed-price");
                    priceSpan.textContent = unframedPrice.replace(" ", "").replace(".00", "");
                    priceSpan.style.display = "block";
                    priceSpan.style.color = "#333";
                    sizeSpan.insertAdjacentElement("afterend", priceSpan)
                }
            }
        }
    })
}
document.addEventListener("DOMContentLoaded", function() {
    appendUnframedPrices(!1);
    appendUnframedPrices(!0)
});
document.addEventListener("on:quickbuy:after-open", function(e) {
    var quickbuyContainer = e.target;
    var inner = quickbuyContainer.querySelector(".inner");
    if (!inner) return;
    var mainSlider = inner.querySelector(".splide#main-slider");
    var thumbSlider = inner.querySelector(".splide#thumbnail-slider");
    if (mainSlider && thumbSlider) {
        var uniqueId = Date.now();
        mainSlider.id = "main-slider-quickbuy-" + uniqueId;
        thumbSlider.id = "thumbnail-slider-quickbuy-" + uniqueId;
        var main = new Splide("#" + mainSlider.id, {
            type: "loop",
            rewind: !0,
            pagination: !1,
            arrows: !0,
            autoHeight: !1,
        });
        var thumbnails = new Splide("#" + thumbSlider.id, {
            fixedWidth: 90,
            fixedHeight: 90,
            rewind: !0,
            pagination: !1,
            cover: !0,
            isNavigation: !0,
            arrows: !0,
            gap: 3,
            breakpoints: {
                767: {
                    fixedWidth: 88,
                    fixedHeight: 88,
                    arrows: !1,
                },
            },
        });
        var updateHeight = function() {
            var slide = main.Components.Slides.getAt(main.index).slide;
            if (slide) {
                main.root.style.height = slide.offsetHeight + "px"
            }
        };
        main.sync(thumbnails);
        main.mount().on("active resized", updateHeight);
        updateHeight();
        thumbnails.mount();
        console.log("Quickbuy Splide slider initialized with id: " + uniqueId)
    }
    initializeSelections(!0);
    updatePriceVisibility(!0);
    appendUnframedPrices(!0);
    eventSizeChange(!0)
});
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.announcement-splide').forEach(function(el) {
        const settingSpeed = Number(el.dataset.speed) || 30;
        const speed = settingSpeed * 0.02;
        new Splide(el, {
            type: 'loop',
            autoWidth: !0,
            pagination: !1,
            arrows: !1,
            drag: !1,
            gap: '20px',
            autoScroll: {
                speed: speed,
                pauseOnHover: !0,
                pauseOnFocus: !1,
            },
        }).mount(window.splide.Extensions)
    })
});

(function() {
    function getStorewideConfig() {
        const s = (window.theme && window.theme.settings && window.theme.settings.storewideDiscount) || {};
        return {
            enabled: !!s.enabled,
            value: Number(s.value) || 0,
            badgeText: (s.badgeText || '').trim(),
            excludeSale: !!s.excludeSale,
        };
    }

    function getTierConfig() {
        const s = (window.theme && window.theme.settings && window.theme.settings.tierDiscount) || {};
        return {
            enabled: !!s.enabled,
            tier1Threshold: Number(s.tier1Threshold) || 0,
            tier1Value: Number(s.tier1Value) || 0,
            tier2Threshold: Number(s.tier2Threshold) || 0,
            tier2Value: Number(s.tier2Value) || 0,
        };
    }

    // Returns the cosmetic display discount for a variant: { pct, label }.
    // Mirrors snippets/discount-pct.liquid so server + client always agree.
    function getDiscountInfo(variant) {
        if (!variant) return { pct: 0, label: '' };

        const sw = getStorewideConfig();
        const onSale = variant.compare_at_price > variant.price;
        if (sw.excludeSale && onSale) return { pct: 0, label: '' };

        if (sw.enabled && sw.value > 0) {
            return { pct: sw.value, label: sw.badgeText || (sw.value + '% OFF') };
        }

        const t = getTierConfig();
        if (t.enabled) {
            const cents = variant.price;
            if (t.tier2Value > 0 && cents >= t.tier2Threshold * 100) {
                return { pct: t.tier2Value, label: t.tier2Value + '% OFF $' + t.tier2Threshold + '+' };
            }
            if (t.tier1Value > 0 && cents >= t.tier1Threshold * 100) {
                return { pct: t.tier1Value, label: t.tier1Value + '% OFF $' + t.tier1Threshold + '+' };
            }
        }

        return { pct: 0, label: '' };
    }

    function getVariantPickerData(productRoot) {
        const picker = productRoot?.querySelector('variant-picker');
        if (!picker) return null;
        const dataEl = picker.querySelector('[type="application/json"]');
        if (!dataEl) return null;
        try {
            return JSON.parse(dataEl.textContent);
        } catch (e) {
            return null;
        }
    }

    function applyCosmeticTierPricing(productRoot, variant) {
        if (!productRoot) return;

        const priceEl = productRoot.querySelector('.product-price .price');
        if (!priceEl) return;

        const priceCurrentEl = priceEl.querySelector('.price__current');
        const priceWasEl = priceEl.querySelector('.price__was');
        const tierDiscount = priceEl.querySelector('.pdp-tier-discount');
        const tierDiscountTitle = tierDiscount?.querySelector('.pdp-tier-discount__title');

        if (!priceCurrentEl) return;

        if (!variant) {
            if (tierDiscount) tierDiscount.hidden = true;
            return;
        }

        const pickerData = getVariantPickerData(productRoot);
        const formatted = pickerData?.formatted?.[variant.id];
        const info = getDiscountInfo(variant);
        const tier = info.pct;

        if (tier > 0 && formatted?.tierSalePrice) {
            priceCurrentEl.innerHTML = formatted.tierSalePrice;
            if (priceWasEl) priceWasEl.innerHTML = formatted.price;
            priceEl.classList.add('price--on-sale');

            if (tierDiscount) {
                tierDiscount.hidden = false;
                tierDiscount.dataset.tier = String(tier);
                if (tierDiscountTitle) tierDiscountTitle.textContent = info.label;
            }
            return;
        }

        if (formatted) {
            priceCurrentEl.innerHTML = formatted.price;
            if (priceWasEl) priceWasEl.innerHTML = formatted.compareAtPrice || '';
            priceEl.classList.toggle('price--on-sale', variant.compare_at_price > variant.price);
        }

        if (tierDiscount) {
            tierDiscount.hidden = true;
            tierDiscount.dataset.tier = '0';
            if (tierDiscountTitle) tierDiscountTitle.textContent = '';
        }
    }

    function getProductRoot(quickbuy) {
        if (quickbuy) {
            return document.querySelector('.quickbuy-container .inner .js-product');
        }
        return document.querySelector('.section-main-product .js-product');
    }

    function initCosmeticPricingForProduct(productRoot) {
        if (!productRoot) return;
        const pickerData = getVariantPickerData(productRoot);
        if (!pickerData) return;

        const idInput = productRoot.querySelector('.js-product-form [name="id"], form.js-product-form [name="id"]');
        const variantId = idInput?.value;
        const variant = pickerData.variants.find((v) => String(v.id) === String(variantId));
        applyCosmeticTierPricing(productRoot, variant || pickerData.variants[0]);
    }

    function initAllCosmeticPricing() {
        document.querySelectorAll('.js-product').forEach(initCosmeticPricingForProduct);
    }

    function scheduleCosmeticPricing(productRoot, variant) {
        requestAnimationFrame(() => {
            applyCosmeticTierPricing(productRoot, variant);
        });
    }

    window.snoogRefreshCosmeticPricing = function(quickbuy) {
        const productRoot = getProductRoot(quickbuy);
        if (!productRoot) return;
        requestAnimationFrame(() => initCosmeticPricingForProduct(productRoot));
    };

    document.addEventListener('on:variant:change', (e) => {
        scheduleCosmeticPricing(e.target.closest('.js-product'), e.detail.variant);
    });

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAllCosmeticPricing);
    } else {
        initAllCosmeticPricing();
    }

    document.addEventListener('on:quickbuy:after-open', (e) => {
        requestAnimationFrame(() => {
            const productRoot = e.target.querySelector('.inner .js-product') || e.target.querySelector('.js-product');
            initCosmeticPricingForProduct(productRoot);
        });
    });
})();
